import React, { FC, useCallback, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';

import axios from 'axios';

import Button from '../common/button';
import ModalWrap from '../common/modal-wrap';
import { CloseCrossBtn } from '../icons/close-cross-btn';
import { useAppSelector } from '../../hooks/redux';
import { selectUser } from '../../store/auth.slice';


import { TextArea } from '../common/textarea';

import { IConsultation } from '../../store/types';

import {
  JOURNAL_TAB_GROUP_THERAPY,
  navigateToJournalSession,
} from '../../pages/journal/journal-navigation';

import AdBanner from '../common/banner/adBanner';

import Header from '../header';

import { UnicornReview } from './unicorn-review';


export const PsychologEnd: FC<{ consultation: IConsultation | null }> = ({ consultation }) => {
  const userData = useAppSelector(selectUser);

  const navigate = useNavigate();
  const [hoverUnicorn, setHoverUnicorn] = useState(0);
  const [note, setNote] = useState('');
  const [unicornActive, setUnicornActive] = useState(0);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);

  const navigateToTherapeuticJournal = useCallback(() => {
    if (!consultation) return;
    navigateToJournalSession(navigate, consultation.id, consultation.client_entity, 'Инструменты', {
      isClientActive: true,
      journalTabId: consultation.is_group ? JOURNAL_TAB_GROUP_THERAPY : undefined,
    });
  }, [consultation, navigate]);

  const handleSaveReview = async () => {
    try {
      const data = {
        video_score: unicornActive,
        consultation_score: null,
        note: note,
        consultation: consultation ? `/api/v1/consultations/${consultation.id}` : '',
        author: `/api/v1/users/${userData?.id}`,
        client: null,
      };
      const res = await axios.post(`${import.meta.env.VITE_REACT_APP_API_URL}/api/v1/reviews`, data, {});
      if (res.status >= 200 && res.status < 300) {
        setIsShowModal(true);
        setUnicornActive(0);
        setIsBlocked(true);
        setNote('');
      }
    } catch (error) {
      toast.error('Произошла ошибка');
      console.log(error);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col md:flex-row">
      <div className="flex flex-col bg-[#c5c5c5] items-center justify-center w-full md:max-w-[350px] h-full order-last md:order-first">
        <div className="w-full flex flex-col items-center gap-2.5 pt-[10px]">
          {/* <p className="font-comfortaa text-lg font-bold text-[#585858]">Реклама</p> */}
          <AdBanner />
          {/* <div className="flex w-full max-w-[240px] h-[400px] items-center justify-center bg-[#FFFFFF] rounded-[20px] lg:rounded-[30px]" /> */}
        </div>
      </div>
      <div className="w-full">
        {/* <div className="w-full h-headerHeightMobile lg:h-headerHeight bg-white shadow-shadowHeader">
          <div className="w-full max-w-[1280px] h-full py-[8px] px-[15px] lg:py-2 mx-auto">
            <div className="h-full flex items-center justify-between">
              <div className="flex flex-col">
                <div className="text-xs md:text-base text-black font-bold leading-3 md:leading-4 mb-[3px] md:mb-[7px]">
                  BETA
                </div>
                <Link to={LANDING}>
                  <LogoIcon className="w-[80px] h-[15px] lg:w-[155px] lg:h-[30px]" />
                </Link>
              </div>
              <button
                className="font-comfortaa font-medium flex justify-center py-[6px] lg:py-[10px] px-[30px] bg-blackBase text-white leading-4 w-max rounded-[10px] hover:text-redBase border-2 border-blackBase active:border-redBase active:text-white"
                onClick={onLogout}
              >
                Выйти
              </button>
            </div>
          </div>
        </div> */}
        <Header />
        <div className="pt-6 sm:pt-10 lg:pt-[80px]">
          <div className="pt-6 sm:pt-10 lg:pt-[30px] px-[15px] lg:px-[100px]">
            <h2 className="font-comfortaa font-bold text-xl lg:text-3xl text-center text-blackBlue mb-2.5">
              Видео-конференция завершилась
            </h2>
            <p className="text-greyBase text-sm lg:text-base text-center mb-8">
              ZiNGiZi каждый день старается стать лучше для своих пользователей.
            </p>
            <div className="max-w-[420px] mx-auto bg-white rounded-[15px] lg:rounded-[30px] p-4 shadow-formFeedback mb-8 sm:mb-14">
              <Button
                className="w-full sm:w-max !p-[10px_30px] !text-base !font-medium !leading-4 mb-4"
                onClick={() => {
                  setIsShowModal(false);
                  navigateToTherapeuticJournal();
                }}
              >
                Перейти в Терапевтический журнал
              </Button>
              <p className="font-comfortaa font-bold text-sm lg:text-lg text-center text-blackBase mb-5">
                Оцените качество связи ZiNGiZi
              </p>
              <div className="flex justify-center mb-5 lg:mb-8">
                <UnicornReview
                  hoverUnicorn={hoverUnicorn}
                  unicornActive={unicornActive}
                  setHoverUnicorn={setHoverUnicorn}
                  setUnicornActive={setUnicornActive}
                />
              </div>
              <div className="flex flex-col">
                <TextArea
                  value={note}
                  onChange={setNote}
                  placeholder="Напишите о качестве работы сервиса"
                  label="Дополнительный комментарий"
                />

                <div className="flex flex-col gap-4 items-center">
                  <Button
                    type={'black'}
                    disabled={unicornActive === 0 || isBlocked}
                    className="w-full self-center !text-base !font-medium"
                    onClick={() => handleSaveReview()}
                  >
                    Отправить
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <ModalWrap isShow={isShowModal}>
            <div className="max-w-full w-[500px] lg:min-w-[500px] bg-white rounded-[40px] shadow-shadowPopup p-[30px] lg:p-10">
              <div className="flex gap-[20px] justify-between items-center mb-[20px] lg:mb-[40px]">
                <h2 className="font-comfortaa font-bold text-blackBase lg:text-2xl">Спасибо за отзыв</h2>
                <div
                  onClick={() => {
                    setIsShowModal(false);
                    navigateToTherapeuticJournal();
                  }}
                >
                  <CloseCrossBtn className="hover:cursor-pointer" />
                </div>
              </div>
              <p className="text-sm lg:text-base text-greyBase mb-[30px] lg:mb-[40px]">
                Ваш отзыв успешно отправлен. Он поможет улучшить работу сервисов ZiNGiZi.
              </p>
              <div className="flex justify-center">
                <Button
                  type={'black'}
                  className="w-full sm:w-max !p-[10px_30px] !text-base !font-medium !leading-4 "
                  onClick={() => {
                    setIsShowModal(false);
                    navigateToTherapeuticJournal();
                  }}
                >
                  Перейти в Терапевтический журнал
                </Button>
              </div>
            </div>
          </ModalWrap>
        </div>
      </div>
    </div>
  );
};
